export const devCommonUrl = {
  AUTOPASS_URL: 'https://jupiter-alpha.pklotcorp.com',
  AUTOPASS_OFFICIAL_URL: 'https://www-alpha.pklotcorp.com',
  CARMOCHI_URL: 'https://carmochi-alpha.pklotcorp.com',
  MOCHIPAY_URL: 'https://alpha-mochipay.pklotcorp.com',
  MAINTENANCE_URL: 'https://maintenance-alpha.pklotcorp.com',
  GUEST_APS_URL: 'https://aps-alpha.pklotcorp.com',
  CONTACT_URL: 'https://contact-alpha.pklotcorp.com',
  MAPS_URL: 'https://maps-alpha.pklotcorp.com',
  BROKER_URL: 'broker-alpha.pklotcorp.com',
  MOCHI_PASS_URL: 'https://pklotcorp.com/mochi_pass',
  DPASS_URL: 'https://app-alpha.pass.credit',
};

export const prodCommonUrl = {
  AUTOPASS_URL: 'https://autopass.xyz',
  AUTOPASS_OFFICIAL_URL: 'https://www.autopass.xyz',
  CARMOCHI_URL: 'https://carmochi.com',
  MOCHIPAY_URL: 'https://mochipay.xyz',
  MAINTENANCE_URL: 'https://maintenance.autopass.xyz',
  GUEST_APS_URL: 'https://aps.autopass.xyz',
  CONTACT_URL: 'https://contact.autopass.xyz',
  MAPS_URL: 'https://maps.autopass.xyz',
  BROKER_URL: 'broker.autopass.xyz',
  MOCHI_PASS_URL: 'https://autopass.xyz/mochi_pass',
  DPASS_URL: 'https://app.pass.credit',
};
